export { DefaultGateway } from './DefaultGateway/DefaultGateway';
export { DHCPEnabled } from './DHCPEnabled/DHCPEnabled';
export { IPAddress } from './IPAddress/IPAddress';
export { IPPort } from './IPPort/IPPort';
export { Name } from './Name/Name';
export { SubnetMask } from './SubnetMask/SubnetMask';
